/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_6_AInputs */

const en_mk_faq_6_a = /** @type {(inputs: Mk_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onboarding takes five minutes with no forced migration — start a fresh workspace and keep WhatsApp as the inbound/outbound channel your team already knows.`)
};

const id_mk_faq_6_a = /** @type {(inputs: Mk_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onboarding 5 menit tanpa migrasi paksa — mulai dari workspace baru, dan biarkan WhatsApp tetap jadi kanal masuk-keluar yang sudah biasa dipakai timmu.`)
};

/**
* | output |
* | --- |
* | "Onboarding takes five minutes with no forced migration — start a fresh workspace and keep WhatsApp as the inbound/outbound channel your team already knows." |
*
* @param {Mk_Faq_6_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_6_a = /** @type {((inputs?: Mk_Faq_6_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_6_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_6_a(inputs)
	return en_mk_faq_6_a(inputs)
});